import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { Browser } from '@capacitor/browser';
import { IonicModule } from '@ionic/angular';
import { Component, inject, OnInit } from '@angular/core';
import { ThemeService } from '../../../_core/services/theme.service';

@Component({
  standalone: true,
  selector: 'app-ita-ad',
  templateUrl: './ita-ad.component.html',
  styleUrls: ['./ita-ad.component.scss'],
  imports: [IonicModule]
})
export class ItaAdComponent {
themeService = inject(ThemeService);
  constructor() { }

  async openLink() {
    Browser.open({url: 'https://news.intennse.com/exclusive-intennse-webinar-a-new-era-of-tennis/?ref=iOnCourt'});

    await FirebaseAnalytics.logEvent({
      name: "Intennse Ad",
      params: {
          timestamp: new Date(),
      },
  });
  }
}
